import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ReactComponent as BrandBanner } from '../../../assets/images/login/brand.svg';
import { useBranding } from '../../../contexts/BrandingContext';

import ConsumerDelete from './ConsumerDelete';
import ForgetPassword from './ForgetPassword';
import LoginComponent from './LoginComponent';
import NewPasswordChange from './NewPasswordChange';
import OTPVerification from './OTPVerification';

/**
 * Login component
 * @returns {React.JSX.Element} The rendered Login component.
 * @description Login component is a component for login functionality.
 */
function LoginV2(): React.JSX.Element {
  const { t, i18n } = useTranslation('loginV2');
  const { page } = useParams<Record<string, string>>();
  const { brandData } = useBranding();
  const runtimeLogo = brandData?.logo;

  const hindMessage = [
    {
      key: 'credentials',
      title: t('getStartedNow'),
      message: t('enterYourCredentialAccessYourAccount'),
    },
    {
      key: 'otp-verification',
      title: t('otpVerification'),
      message: t('pleaseEnterTheOtpReceivedThatWhichYouRegisteredEmailId'),
    },
    {
      key: 'forgot-password',
      title: t('forgotPassword'),
      message: t('pleaseEnterTheRegisteredPhoneNumberEmailId'),
    },
    {
      key: 'consumer-delete',
      title: t('consumerDelete'),
      message: t('pleaseEnterTheRegisteredPhoneNumberEmailId'),
    },
  ];

  return (
    <div className="login-wrapper" dir={i18n.dir()}>
      <div className="login-content">
        <div className="login-content-top">
          <div className="brand-container">
            <div className="backdrop">
              <div className="red" />
              <div className="green" />
            </div>
            {runtimeLogo ? (
              <img src={runtimeLogo} alt="brand" className="brand-banner" />
            ) : (
              <BrandBanner className="brand-banner" />
            )}
          </div>
          <div className="text-container">
            <p className="title">{hindMessage.find((item) => item.key === page)?.title}</p>
            <p className="description">{hindMessage.find((item) => item.key === page)?.message}</p>
          </div>
        </div>
        <div className="login-content-bottom">
          <div className="login-page-content">
            {(() => {
              let pageContent;
              if (page === 'forgot-password') {
                pageContent = <ForgetPassword />;
              } else if (page === 'consumer-delete') {
                pageContent = <ConsumerDelete />;
              } else if (page === 'otp-verification') {
                pageContent = <OTPVerification />;
              } else if (page === 'new-password') {
                pageContent = <NewPasswordChange />;
              } else {
                pageContent = <LoginComponent />;
              }
              return pageContent;
            })()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginV2;
